/**
 * Bundle entry point for the `<wexio-widget>` custom element.
 *
 * Loaded via `<script type="module" src="https://cdn.wexio.io/widget.js">`
 * on the host page. The script registers the custom element side-effectfully
 * so any `<wexio-widget>` in the DOM (before OR after this script runs)
 * upgrades to the live component.
 */
import { WexioWidgetElement } from "./wexio-widget";

// `customElements.define` throws if called twice with the same name.
// Guard so hot-reload / multiple-include scenarios degrade gracefully.
if (typeof window !== "undefined" && !customElements.get("wexio-widget")) {
  customElements.define("wexio-widget", WexioWidgetElement);
}

export { WexioWidgetElement };
